import {
	FETCH_QUESTIONS_REQUEST,
	FETCH_QUESTIONS_SUCCESS,
	FETCH_QUESTIONS_FAIL,
	UPDATE_QUESTION_REQUEST,
	UPDATE_QUESTION_SUCCESS,
	UPDATE_QUESTION_FAIL,
	FETCH_QUESTION_REQUEST,
	FETCH_QUESTION_SUCCESS,
	FETCH_QUESTION_FAIL,
	CREATE_QUESTION_REQUEST,
	CREATE_QUESTION_SUCCESS,
	CREATE_QUESTION_FAIL,
	DELETE_QUESTION_REQUEST,
	DELETE_QUESTION_SUCCESS,
	DELETE_QUESTION_FAIL,
} from "../constants/question";

function fetchQuestionsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			questionDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_QUESTIONS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_QUESTIONS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				questions: action.payload,
			};
		case FETCH_QUESTIONS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateQuestionReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_QUESTION_REQUEST:
			return { loading: true };
		case UPDATE_QUESTION_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
			};
		case UPDATE_QUESTION_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function fetchQuestionReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null };
	}
	switch (action.type) {
		case FETCH_QUESTION_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_QUESTION_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				question: action.payload,
			};
		case FETCH_QUESTION_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function createQuestionReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case CREATE_QUESTION_REQUEST:
			return { loading: true };
		case CREATE_QUESTION_SUCCESS:
			return { loading: false, success: true, question: action.payload };
		case CREATE_QUESTION_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function deleteQuestionReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_QUESTION_REQUEST:
			return { loading: true };
		case DELETE_QUESTION_SUCCESS:
			return {
				loading: false,
				questionDeleted: true,
			};
		case DELETE_QUESTION_FAIL:
			return { loading: false, questionDeleted: false, error: action.payload };
		default:
			return state;
	}
}

export {
	fetchQuestionsReducer,
	updateQuestionReducer,
	fetchQuestionReducer,
	createQuestionReducer,
	deleteQuestionReducer,
};
